import { BREAKPOINTS } from '@/theme/breakpoints'

export type DeviceClass = 'mobile' | 'tablet' | 'desktop'

/**
 * Classifies the device from its primary pointer and physical screen size rather than the
 * viewport, which is pinned to a desktop width while responsive layouts are disabled.
 */
export function resolveDeviceClass(): DeviceClass {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'desktop'
  if (!window.matchMedia('(pointer: coarse)').matches) return 'desktop'
  const shortSide = Math.min(window.screen.width, window.screen.height)
  return shortSide < BREAKPOINTS.sm ? 'mobile' : 'tablet'
}
